module.exports = __webpack_public_path__ + "register/img/ca.ad152714.svg";